import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {all_routes} from "../../../router/all_routes";
import {Log,DateTime,Num} from "biz9-utility";
import {Page_Logic,Portal_Type,Portal_Field,Portal_Url,Portal_Title,Portal_Table,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Data} from "biz9-portal-app";
import {Review_Url,Review_Table} from "biz9-review";
import {Image_Format} from "biz9-image";
import {User_Table} from "biz9-user";
import {Data_Logic} from "biz9-data-app";
import {Field,Message,Title,Type,Url} from "../../../../constant";

import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Toast_Message,Template,Storage,System,User} from "../../../../project";
/* -- biz9 import end -- */
const Dashboard_User_Review = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [user,setUser] = useState(User.get());
    const [val_sub_page_title,setValSubPageTitle] = useState("Reviews");
    const [reviews,setReviews] = useState([]);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Review_Table.REVIEW,{user_id:user.id});
        let foreign_parent = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.PRODUCT,Portal_Field.ID,Portal_Field.PARENT_ID);
        let foreign_user = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.USER,Portal_Field.ID,Portal_Field.PARENT_ID);
        let option =  {foreigns:[foreign_parent,foreign_user]};
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setReviews(data.reviews);
        Toast_Message.dismiss();
    };
    async function btn_delete(id: any) {
        if (window.confirm('Are you sure?')) {
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Review_Table.REVIEW,id);
            Toast_Message.success(response.message);
            setReviews(reviews.filter(item=>item.id!==id));
        }
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            {/*User Reviews */}
            <div className="col-xl-12 col-lg-12">
            <div className="user-review">
            <ul className="review-lists">
            {reviews.map((item) => (
                        <li>
                        <div className="review-wrap">
                        <div>
                        <div className="review-user-info">
                        <div className="review-img">
                        <Link target='_blank' to={"/app/"+item.product_title_url}>
                        <ImageWithBasePath
                        src={Image.get_url(item.product_image_filename,Image_Format.SQUARE_THUMB)}
                        alt=""
                        />
                        </Link>
                        </div>
                        <div className="reviewer-info">
                        <div className="reviewer-loc">
                        <h6>
                        <Link  target='_blank' to={item.product_title_url ? "/app/"+item.product_title_url :"#" }>{item.product_title?item.product_title:'BoSS AppZ'} </Link> {" - "}
                        <Link  target='_blank' to={all_routes.dashboard_admin_user_detail +"?id="+item.user_id}>{item.user_title} </Link>
                        </h6>
                        </div>
                        <div className="reviewer-rating">
                        <div className="star-rate">
                        <span className="ratings">
                        {Array.from({ length: parseInt(item.rating) }).map((_, index) => (
                                    <i className="fa-solid fa-star filled" />
                                    ))}
                        </span>
                            <span className="rating-count">{Num.get_decimal(item.rating)}</span>
                            </div>
                            <p>{DateTime.get_pretty(item.date_create)}</p>
                            </div>
                            </div>
                            </div>
                            <div className="review-content">
                            <h6>
                            {item.title}
                        </h6>
                            <p>
                            {item.comment}
                        </p>
                            </div>
                            </div>
                            <div className="table-action">
                            <Link to="#">
                            <FeatherIcon icon="trash" onClick={(e) => { {btn_delete(item.id)} }} />
                            </Link>
                            </div>
                            </div>
                            </li>
                            ))}
    </ul>
        </div>
        </div>
        {/* /User Reviews */}
    </div>
        </div>
        {/* /Page Content */}
    </>
        );
};
export default Dashboard_User_Review;
